import React, { useEffect, useState } from 'react'
import {makeStyles} from '@material-ui/core'
import { useData } from '../../../data'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import DashboardLayout, { DashboardPage } from '../layout'
import {Form, Divider, Button, Input, Switch, Typography, notification} from 'antd'
import moment from 'moment'
import UpdatePassword from './update_password'

const {Text} = Typography

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
        width: '100%'
    },
    content: {
        padding: theme.spacing(2)
    },
    details: {
        maxWidth: '30%'
    },
    title: {
        marginBottom: theme.spacing(4)
    },
    date: {
        fontSize: 20
    },
    text: {
        fontSize: 16
    }
}))

/**
 * User profile page
 * 
 * Shows user information and has input controls to allow users to edit their information
 */

const UserProfile = (props) => {
    const [user, setUser] = useState(null)

    const classes = useStyles()
    const data = useData()
    const auth = data.auth()

    // load the current user 
    const loadUser = () => {
        trackPromise(
            auth.getCurrentUser()
                .then(setUser)
                .catch(console.log), 'get_user'
        )
    }

    // get the currently signed in user
    useEffect(() => {
        loadUser()
        // eslint-disable-next-line
    }, [])

    // update a user profile with collected information
    const updateProfile = (vals) => {
        const {id} = user 
        
        trackPromise(
            auth.updateUserInfo({...vals, id})
                .then(() => {
                    loadUser()
                    notification.success({
                        message: "Updated",
                        description: "Succesfully updated your profile information"
                    })
                })
                .catch((err) => {
                    notification.error({
                        message: "Error",
                        description: "An error occured updating your profile info. See console for logs"
                    })

                    console.log(err.message)
                }), 'update'
        )
    }

    const loading = usePromiseTracker({area: 'update'}).promiseInProgress

    return (
        <DashboardLayout selected="profile">
            <DashboardPage
                title="Profile"
                hasCta={false}
            >
                <div className={classes.root}>
                    <div className={classes.content}>
                        <div className={classes.details}>
                            <h1 className={classes.title}>Public profile</h1>

                            {
                                user && (
                                    <div>
                                        <Form
                                            layout="vertical"
                                            onFinish={updateProfile}
                                            initialValues={user}
                                        >
                                            <Form.Item label="Email">
                                                <Input disabled size="large" value={user.email} />
                                            </Form.Item>
                                            <Form.Item label="First name" name="first_name">
                                                <Input size="large" />
                                            </Form.Item>
                                            <Form.Item label="Last name" name="last_name" >
                                                <Input size="large" />
                                            </Form.Item>
                                            <Form.Item label="Is admin" >
                                                <Switch checked={user.is_superuser} disabled  size="large" />
                                            </Form.Item>
                                            <Form.Item label="Date joined">
                                                <p className={classes.date}>{moment(user.date_joined).format("YYYY-MM-DD HH:mm a")}</p>
                                            </Form.Item>

                                            <Form.Item>
                                                <Text className={classes.text} type="secondary">All fields on this page left inactive can be deleted or edited anytime.</Text>
                                            </Form.Item>
                                            <Form.Item>
                                                <Button type="primary" htmlType="submit" loading={loading}>Update profile</Button>
                                            </Form.Item>
                                            
                                        </Form>
                                        <Divider />
                                        <h1>Change password</h1>

                                        <UpdatePassword user={user} />
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </DashboardPage>
        </DashboardLayout>
    )

}

export default UserProfile